"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * `Svg` styled component.
 */


var Svg = _styledComponents.default.span.withConfig({
  displayName: "icon__Svg",
  componentId: "sc-1bqmkw5-0"
})(["display:", ";line-height:0;max-width:", ";position:relative;width:", ";", " ", ""], (0, _styledTools.ifProp)('block', 'block', 'inline-block'), (0, _styledTools.prop)('size'), (0, _styledTools.prop)('size'), (0, _styledTools.ifProp)('innerColor', (0, _styledComponents.css)(["color:", ";"], (0, _styledTools.prop)('innerColor'))), (0, _styledTools.ifProp)('responsive', (0, _styledComponents.css)(["width:100%;"])));
/**
 * `Icon` component.
 */


var Icon = function Icon(_ref) {
  var color = _ref.color,
      icon = _ref.icon,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "icon", "size"]);

  var innerHtml = {
    __html: icon // eslint-disable-line id-match

  };
  return _react.default.createElement(Svg, _extends({}, rest, {
    dangerouslySetInnerHTML: innerHtml,
    innerColor: color,
    size: size
  }));
};
/**
 * Export `Icon` component.
 */


var _default = Icon;
exports.default = _default;